import styled from "styled-components";
import { C3Text } from "../text/CustomText";
import { Theme } from "../../Theme";

const TableContainer = styled.div`
    border: 1px solid ${Theme.color.gray200};
    border-radius: 12px;
    overflow: hidden;
    width: 100%;
`;

const TableRow = styled.div`
    display: grid;
    grid-template-columns: 0.8fr 2.4fr;
    border-bottom: 1px solid ${Theme.color.gray200};

    &:last-child {
        border-bottom: none;
    }
`;

const TableCell = styled.div`
    padding: 11px 16px;

    &:first-child {
        background-color: ${Theme.color.neutral100};
        border-right: 1px solid ${Theme.color.gray200};
    }
`;

const sampleData = [
    { title: "Device No.", value: "W001" },
    { title: "Type", value: "Washer" },
    { title: "Model", value: "FH069FD_T" },
    { title: "Device ID", value: "84960297-c1fa-16b3-a339-60ab148ff8e8" },
];

export function InfoTable({ data = sampleData }) {
    return (
        <TableContainer>
            {data.map((item) => (
                <TableRow key={item.title}>
                    <TableCell>
                        <C3Text fontWeight="500">{item.title}</C3Text>
                    </TableCell>
                    <TableCell>
                        <C3Text
                            fontColor={Theme.color.neutral700}
                            style={{ textDecoration: item.isLink ? "underline" : "none" }}
                            cursor={item.isLink ? "pointer" : "default"}
                            onClick={item.onClick}
                        >
                            {item.value}
                        </C3Text>
                    </TableCell>
                </TableRow>
            ))}
        </TableContainer>
    );
}
